import { render, staticRenderFns } from "./CartStatus.vue?vue&type=template&id=495020cb&lang=pug&"
import script from "./CartStatus.vue?vue&type=script&lang=js&"
export * from "./CartStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports